import React, { useEffect, useState } from 'react';
import firebase, { firebaseAnalytics }  from './Firebase';
import { Button, Table, Spinner } from "react-bootstrap";
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faInfinity } from '@fortawesome/free-solid-svg-icons';

export default function Sconti() {  

    const [weed, setWeed] = useState([]);
    const [shop, setShop] = useState([]);
    const [seeds, setSeeds] = useState([]);
    const [loading, setLoading] = useState([]);  
    const ref = firebase.firestore().collection("codici");
    let history = useHistory();

    useEffect(() => {
        firebaseAnalytics.logEvent("sconti_tab_visited");
        firebaseAnalytics.setCurrentScreen("sconti_tab")
        setLoading(true);
        ref.onSnapshot((query)  => {updateState(query)});
        setLoading(false)
    }, []);

    const updateState = query => {
        var items = [];
        query.forEach(doc => items.push(doc.data()));
        setSeeds(items[0][0])
        setShop(items[1][0])
        setWeed(items[2][0])
        setLoading(false);
    }


    const renderRow = (item) => {
        if(item.inizio !== null && item.inizio.seconds*1000 > Date.now()) { return null }

        return(
        <tr>
            <th style= {{verticalAlign: "middle"}}>
                <div style={{justifyContent: "center", alignItems: "center", wordWrap:"anywhere"}} >
                    <img src={item.logo} height="45px" width="45px" style={{borderRadius: "100%"}}/>
                    <br/>
                    <text style={{fontWeight: 400}}>{item.azienda}</text>
                </div>
            </th>
            <th style= {{verticalAlign: "middle"}}>
                <text style= {{fontSize: "200%" }}>-{item.sconto}</text>
                
                <div style={{ backgroundColor: "rgb(194, 194, 194)", borderRadius: "5px", paddingInline: "10px", cursor: "pointer"}} onClick={() => {navigator.clipboard.writeText(item.codice)}}>
                    <text style={{color: "#2c2c32"}} > 
                        {item.codice} 
                    </text>
                </div>
                
            </th>
            <th style= {{verticalAlign: "middle"}}>
                <text style={{fontSize: "10px", fontWeight: 400}}>Scadenza:</text>
                {item.fine === null ? 
                <>
                    <br/>
                    <FontAwesomeIcon icon={faInfinity} />
                </>
                : 
                <>
                    <br/>
                    {new Date(item.fine.toDate()).toLocaleDateString()}
                </>}
                <br/>
                <Button style={{marginTop: "10%"}} onClick={ () => window.open(item.sito, "_blank")}>
                    VAI <FontAwesomeIcon icon={faExternalLinkAlt} />
                </Button>
            </th>
        </tr>
        )   
    }


  return (
      <>
    {loading ? 
        <h2 style={{ color: 'white' }}>
            <Spinner animation="grow" />
        </h2>
        :
    <>
    <h1 style={{color: "white"}}>Codici sconto</h1>
    <div class="row" style={{justifyContent: "space-evenly", marginInline: "0%"}}>
        {/* sconti ERBE */}
        <div style={{ marginInline: "1%"}}>
            <br/>
            <h4 style={{color: "white"}}>Cannabis Light</h4>
            <Table striped bordered hover variant="dark"  >
                {weed.map(item => renderRow(item))}
            </Table>
        </div>
        {/* sconti SHOP */}
        <div style={{marginInline: "1%"}}>
            <br/>
            <h4 style={{color: "white"}}>Grow & Head Shop</h4>
            <Table striped bordered hover variant="dark"  >
                {shop.map(item => renderRow(item))}
            </Table>
        </div>
        {/* sconti SEMI */}
        <div style={{marginInline: "1%"}}>
            <br/>
            <h4 style={{color: "white"}}>Semi</h4>
            <Table striped bordered hover variant="dark"  >
                {seeds.map(item => renderRow(item))}
            </Table>
        </div>
    </div>
    </>
    }
    </>
    )
  }